import {action, thunk } from 'easy-peasy';
import * as paCheckService from '../../services/paCheck';

const paCheckModel = {
  brandingData: [],
  postData: {},
  pACheckResults: [],

  // GET BRANDING DATA
  setBrandingData: action((state, payload) => {
    state.brandingData = payload;
  }),
  getBrandingData: thunk(async (actions, payload) => {
    return await paCheckService.getBrandingData(payload)
      .then(function (response) {
        actions.setBrandingData(response.data.data);
        return response;
      })
      .catch(function (error) {
        // console.log('Error', error);
        throw error;
      });
  }),

  // GET DIAGNOSIS CODES LIST
  getProcDiagCodes: thunk(async (actions, payload) => {
    return await paCheckService.getProcDiagCodes(payload)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        // console.log('Error', error);
        throw error;
      });
  }),
  
  // GET PA CHECK RESULTS
  setPACheckSubmitData: action((state, payload) => {
    state.postData = payload;
  }),
  setPACheckResults: action((state, payload) => {
    state.pACheckResults = payload;
  }),
  getPACheckResults: thunk(async (actions, payload) => {
    return await paCheckService.getPACheckResults(payload)
      .then(function (response) {
        actions.setPACheckSubmitData(payload);
        actions.setPACheckResults(response.data.data);
        return response;
      })
      .catch(function (error) {
        // console.log('Error', error);
        throw error;
      });
  }),

};

export default paCheckModel;
